import React, { useState } from 'react'
import { BeamDesignerWorkspace } from '@structura/beam-analysis'
import { ShareEditor } from '@structura/sharing'
import { sharingClient } from '../../sharing.config'

/**
 * Concrete beam designer page (/beam/concrete).
 *
 * Independent page shell composing the shared analysis workspace. Concrete-specific
 * panels and integrations (reinforcement, PT/prestressing, links to other concrete
 * apps) belong on this page as the apps diverge.
 */
const ConcreteBeam: React.FC = () => {
  const [sharing, setSharing] = useState<{ id: string; name: string } | null>(null)
  return (
    <>
      <BeamDesignerWorkspace material="concrete" onShareDesign={setSharing} />
      {sharing && (
        <ShareEditor
          client={sharingClient}
          resourceType="beam-design"
          resourceId={sharing.id}
          title={sharing.name}
          onClose={() => setSharing(null)}
        />
      )}
    </>
  )
}

export default ConcreteBeam
